var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircularBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1812_2676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1179 0.705078C5.05766 0.705078 0.941406 4.82133 0.941406 9.88155C0.941406 14.9418 5.05766 19.058 10.1179 19.058C15.1781 19.058 19.2943 14.941 19.2943 9.88155C19.2943 4.82205 15.1781 0.705078 10.1179 0.705078ZM10.1179 17.6364C5.84239 17.6364 2.36301 14.1577 2.36301 9.88155C2.36301 5.60535 5.84239 2.12668 10.1179 2.12668C14.3934 2.12668 17.8727 5.60535 17.8727 9.88155C17.8727 14.1577 14.3941 17.6364 10.1179 17.6364Z",
    fill: "#3C38CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6724 9.1048H10.8292V6.2616C10.8292 5.86923 10.5114 5.55078 10.1184 5.55078C9.72527 5.55078 9.40753 5.86923 9.40753 6.2616V9.1048H6.56433C6.17125 9.1048 5.85352 9.42325 5.85352 9.81562C5.85352 10.208 6.17125 10.5264 6.56433 10.5264H9.40753V13.3696C9.40753 13.762 9.72527 14.0805 10.1184 14.0805C10.5114 14.0805 10.8292 13.762 10.8292 13.3696V10.5264H13.6724C14.0655 10.5264 14.3832 10.208 14.3832 9.81562C14.3832 9.42325 14.0655 9.1048 13.6724 9.1048Z",
    fill: "#3C38CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1812_2676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3529,
    height: 18.3529,
    fill: "white",
    transform: "translate(0.941406 0.705078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircularBlue);
export default __webpack_public_path__ + "static/media/addCircularBlue.efab64556912f7cf405e8e56a6fbfe16.svg";
export { ForwardRef as ReactComponent };